<div class="owner-field">
    <div class="label-container">
        <cerrix-label for="asset-owner">{{
            "assetmanagement.register.assignedLabel" | transloco
        }}</cerrix-label>
        <cerrix-instructions-icon
            class="input-instructions-icon"
            [instructionText]="'assetmanagement.edit-ownership-information.ownerInfo' | transloco"
            [showText]="false"
        ></cerrix-instructions-icon>
    </div>
    <app-cerrix-avatar-group
        data-uiid="asset-avatar-group"
        [names]="ownerNames"
        [showAddButton]="true"
        [addLabel]="'assetmanagement.edit-ownership-information.ownerDialogTitle' | transloco"
        [emptyText]="
            'assetmanagement.edit-ownership-information.ownerSelectorEmptyText' | transloco
        "
        (addRequested)="openOwnerDialog()"
        [showAddButton]="!readonly"
    ></app-cerrix-avatar-group>
</div>

<cerrix-dialog [name]="ownerDialogName">
    <div header-title>
        {{ "assetmanagement.edit-ownership-information.ownerDialogTitle" | transloco }}
    </div>
    <div class="asset-owner-dialog-content" dialog-content>
        <app-cerrix-user-picker
            name="asset-owner"
            [users]="users"
            [(value)]="draftOwnerId"
            [readonly]="readonly"
        ></app-cerrix-user-picker>
    </div>
    <div class="asset-owner-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            data-uiid="asset-owner-dialog-cancel"
            (click)="cancelOwnerSelection()"
            >{{ "assetmanagement.detail.cancelButton" | transloco }}</cerrix-button
        >
        @if (!readonly) {
            <cerrix-button
                buttonSize="big"
                primaryColor="green"
                data-uiid="asset-owner-dialog-confirm"
                (click)="confirmOwnerSelection()"
                >{{
                    "assetmanagement.edit-ownership-information.ownerDialogConfirmText" | transloco
                }}</cerrix-button
            >
        }
    </div>
</cerrix-dialog>
